import * as React from 'react';

import { AppState } from 'common/models/AppState';
// import { EntityActions, EntityType } from 'common/entity';
import { Chapter } from 'common/api/models/Chapter';
// import { Table } from 'reactstrap';
// import { Loading } from 'common/components/Loading';
import { toApiError } from 'common/utils/api';
import { Row, Block } from 'emotion-jsxstyle';
import { ActivityFeedNoteForm } from 'common/components/activity/ActivityFeedNoteForm';
import { InfiniteList } from 'common/components/InfiniteList';
import { Activity } from 'common/api/models/Activity';
import { ActivityApi } from 'common/api/resources/ActivityApi';
import { EntityActions, EntityType } from 'common/entity';
import { MemberLink } from 'common/components/link/MemberLink';
import { Datetime } from 'common/components/Datetime';
import { Money } from '../../common/components/Money';
import { Feature } from 'common/features/Feature';
import { canViewBadges } from 'common/features/canViewBadges';
import * as addDays from 'date-fns/add_days';

export interface ChaptersDetailNotesProps {
  chapter: Chapter;
  appState: AppState;
  entityActions: EntityActions;
  entityId: string;
}

export interface ChaptersDetailNotesState {
  isLoading: boolean;
  activity: Activity[];
  next?: string;
  error?: string;
  isNoteOpen: boolean;
  filterType: string;
}

export class ChaptersDetailNotes extends React.Component<ChaptersDetailNotesProps, ChaptersDetailNotesState> {
  state: ChaptersDetailNotesState = {
    isLoading: false,
    activity: [],
    isNoteOpen: false,
    filterType: 'CHAPTER_NOTE',
  };

  componentDidMount() {
    this.reload(this.props.entityId);
  }

  handleToggleNote = () => {
    this.setState({ isNoteOpen: !this.state.isNoteOpen });
    this.reload(this.props.entityId);
  };

  reload = (entityId: string, from?: string) => {
    // this.props.entityActions.refetch(EntityType.MEMBER, this.props.chapter.id!);
    this.setState({ isLoading: true });
    ActivityApi.findActivity({
      entityId: entityId,
      from: from,
      type: this.state.filterType,
      subType: this.state.filterType,
    }).then(
      res => {
        this.setState({
          activity: from ? this.state.activity.concat(res.data!) : res.data!,
          next: res.next,
          isLoading: false,
        });
        for (let a of res.data!) {
          this.props.entityActions.fetch(EntityType.MEMBER, a.createId!);
        }
      },
      err => {
        this.setState({ error: toApiError(err), isLoading: false });
      }
    );
  };
  handleLoadMore = () => {
    this.reload(this.props.entityId, this.state.next);
  };
  handleError = (err: Error) => this.setState({ error: toApiError(err), isLoading: false });

  handleChangeFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ filterType: e.currentTarget.value, next: undefined }, () => {
      this.reload(this.props.entityId);
    });
  };

  render() {
    const activity = this.state.activity!;
    const entities = this.props.appState.entities;

    console.log('Test: ' + activity);

    return (
      <div>
        <Row alignItems="center" justifyContent="space-between" flexWrap="wrap" paddingTop=".5rem">
          <Block margin=".5rem 0">
            <button className="btn  btn-secondary" onClick={this.handleToggleNote}>
              <i className="fa fa-sticky-note-o" /> Add Note
            </button>
          </Block>
          <Block alignSelf="flex-end" margin=".5rem 0">
            <label>Filter</label>
            <select
              className="form-control"
              style={{ marginLeft: 10, width: 300, minWidth: 300, display: 'inline-block' }}
              value={this.state.filterType}
              onChange={this.handleChangeFilter}
            >
              {/* <option value="">All activity</option> */}
              <option value="CHAPTER_POSITION_HISTORY">Chapter officer History</option>
              <option value="CHAPTER_NOTE">Chapter Note</option>
            </select>
          </Block>
        </Row>
        {this.state.isNoteOpen && (
          <ActivityFeedNoteForm
            entityId={this.props.entityId!}
            entityType="CHAPTER"
            onSave={this.handleToggleNote}
            onCancel={this.handleToggleNote}
          />
        )}
        {this.state.activity.length === 0 && (
          <div className="row" style={{ marginTop: 10 }}>
            <div className="col">No activity.</div>
          </div>
        )}

        <InfiniteList
          className="feed mb-4"
          hasMore={!!this.state.next}
          isLoading={this.state.isLoading}
          onLoadMore={this.handleLoadMore}
        >
          {this.state.activity.map(a => (
            <div key={a.id} className="card card-responsive mt-2">
              <div className="card-block">
                <h6 className="card-title">
                  <small>
                    <b>
                      <MemberLink member={entities.member[a.createId!]} />
                    </b>{' '}
                    <span className="text-muted">
                      <Datetime at={a.createAt} imprecise={true} />
                    </span>{' '}
                  </small>
                </h6>
                <h6>
                  <b>
                    {a.type === Activity.Type.DUES && (
                      <span>
                        Paid dues: <Money value={a.amount!} /> for <Datetime at={a.startDate} format="MM/DD/YY" />{' '}
                        through <Datetime at={addDays(a.endDate!, -1)} format="MM/DD/YY" />
                      </span>
                    )}
                    {a.type === Activity.Type.MEMBER_APPLICATION && <span>Applied for membership</span>}
                    {a.type === Activity.Type.MEMBER_REINSTATE && <span>Reinstated membership</span>}
                    {a.type === Activity.Type.MEMBER_REREGISTER && <span>Reregistered membership</span>}
                    {a.type === Activity.Type.MEMBER_TERMINATE && <span>Terminated membership</span>}
                    {a.type === Activity.Type.ORDER && (
                      <span>
                        Ordered: {a.description} x{a.quantity} <Money value={a.amount!} />
                      </span>
                    )}
                    {a.type === Activity.Type.MEETING && <span>Held meeting</span>}
                    {a.type === Activity.Type.EMAIL && <span>Emailed</span>}
                    {a.type === Activity.Type.LETTER && <span>Mailed letter</span>}
                    {a.type === Activity.Type.CALL && <span>Phone call</span>}
                    {canViewBadges(Feature.badges, this.props.appState.config, this.props.appState.user) && (
                      <>
                        {a.type === Activity.Type.BADGE_MEETING && (
                          <span>
                            <i className="fa fa-certificate" /> Badge Event (In-Person)
                          </span>
                        )}
                        {a.type === Activity.Type.BADGE_VIRTUAL && (
                          <span>
                            <i className="fa fa-certificate" /> Badge Event (Virtual)
                          </span>
                        )}
                      </>
                    )}
                    {a.type === Activity.Type.INFO && <span>Info</span>}
                    {a.type === Activity.Type.AWARD && <span>Received award</span>}
                    {a.type === Activity.Type.REFUND && (
                      <span>
                        Issued refund: <Money value={a.amount!} />
                      </span>
                    )}
                    {a.type === Activity.Type.COUPON && <span>Coupon</span>}
                    {a.type === Activity.Type.NOTE && (
                      <span>
                        <i className="fa fa-sticky-note-o" /> Note
                      </span>
                    )}
                    {a.type === Activity.Type.POINTS && (
                      <span>
                        <i className="fa fa-graduation-cap" /> Earned {Number(a.units).toFixed(2)} CEU credits
                      </span>
                    )}
                    {a.type === Activity.Type.CUSTOM && (
                      <span>
                        {a.customType === 'COMMITTEE' && (
                          <span>
                            Committee assignment <Datetime at={a.startDate} format="MM/DD/YY" /> to{' '}
                            <Datetime at={a.endDate} format="MM/DD/YY" />
                          </span>
                        )}
                        {a.customType !== 'CEU' && a.customType !== 'COMMITTEE' && <span>{a.customType}</span>}
                        {a.customType === 'TRANSCRIPT' && a.units && <span>: earned {a.units} Education Hours</span>}
                        {a.startDate && <Datetime at={a.startDate} format="MM/DD/YY" />}
                        {a.endDate && (
                          <span>
                            {' '}
                            ending <Datetime at={a.endDate} format="MM/DD/YY" />
                          </span>
                        )}
                      </span>
                    )}
                    {a.type === Activity.Type.CHAPTER_POSITION_HISTORY && (
                      <span>
                        <i className="fa fa-sticky-note-o" /> Chapter Position History
                      </span>
                    )}
                    {a.type === Activity.Type.LEARNING_PROGRAM_BADGE && (
                      <span>
                        <i className="fa fa-sticky-note-o" /> Badge Learning Program
                      </span>
                    )}
                    {a.type === Activity.Type.INDIVIDUAL_LEARNING_PROGRAM_BADGE && (
                      <span>
                        <i className="fa fa-sticky-note-o" /> Individual Badge Learning Program
                      </span>
                    )}
                    {a.type === Activity.Type.LEARNING_PROGRAM_CERTIFICATION && (
                      <span>
                        <i className="fa fa-sticky-note-o" /> Certification Learning Program
                      </span>
                    )}
                  </b>
                </h6>
                {a.note && <div>{a.note.split('\n').map((line, i) => <div key={a.id! + i}>{line}</div>)}</div>}
                {a.description && <div>{a.description}</div>}
              </div>
            </div>
          ))}
        </InfiniteList>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Chapters/ChaptersDetailNotes.tsx